import { RouteNames as AboutRouteNames } from './about'
import { RouteNames as CameraManagementRouteNames } from './cameraManagement'
import { RouteNames as ClassesRouteNames } from './classes'
import { RouteNames as DatapoolsRouteNames } from './datapools'
import { RouteNames as MembersRouteNames } from './members'
import { RouteNames as MonitoringRouteNames } from './monitoring'
import { RouteNames as PluginsRouteNames } from './plugins'
import { RouteNames as ProjectsRouteNames } from './projects'
import { RouteNames as ResourcesRouteNames } from './resources'
import { RouteNames as SettingsRouteNames } from './settings'
import { RouteNames as TopologyRouteNames } from './topology'


export type ModuleRouteNames =
  | AboutRouteNames
  | CameraManagementRouteNames
  | ClassesRouteNames
  | DatapoolsRouteNames
  | MonitoringRouteNames
  | MembersRouteNames
  | PluginsRouteNames
  | ProjectsRouteNames
  | ResourcesRouteNames
  | SettingsRouteNames
  | TopologyRouteNames

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ModuleRouteNames = {
  ...AboutRouteNames,
  ...CameraManagementRouteNames,
  ...ClassesRouteNames,
  ...DatapoolsRouteNames,
  ...MonitoringRouteNames,
  ...MembersRouteNames,
  ...PluginsRouteNames,
  ...ProjectsRouteNames,
  ...ResourcesRouteNames,
  ...SettingsRouteNames,
  ...TopologyRouteNames,
} as const
